// extracted by mini-css-extract-plugin
module.exports = {"fab":"styles_fab__gsNA_","menu":"styles_menu__8Nu1k","menuItem":"styles_menuItem__L6diM","menuItemText":"styles_menuItemText__oXEQY"};